import { useMemo } from 'react'

import { ActForm, useCurrentUser } from '@builddocs/data-management'
import { ActFormKeys, Application } from '@builddocs/filestore-api'
import { DocsTypes } from '@builddocs/shared/feature-pdf-viewer'
import { Box } from '@mui/material'

import SigningActTasks from './SigningActTasks'
import StampsOnDocument from './StampsOnDocument'

type OwnProps = {
  document: DocsTypes
  toReopenInspection: boolean
  canShowSigningActions: boolean
  rights: {
    canEdit: boolean
    canInspect: boolean
    canSendActToSigning: boolean
    canSignAct: boolean
  }
  onUpdatePDF?: () => void
}

export const SigningTasks = ({
  toReopenInspection,
  canShowSigningActions,
  rights,
  document,
  onUpdatePDF,
}: OwnProps) => {
  const { user } = useCurrentUser()
  const documentType = document['actType'] ?? document['documentType']

  const isCreator: boolean = useMemo(
    () => ('creatorId' in document ? document.creatorId === user.userId : true),
    [document, user?.userId],
  )

  return (
    <Box>
      {Application[documentType] && (
        <StampsOnDocument
          creatorId={document['creatorId']}
          docId={document.id}
          documentType={documentType as Application}
          hideDeleteStampsButton={rights.canEdit && isCreator}
          showDescription={true}
          sourceId={document['sourceId']}
          onUpdatePDF={onUpdatePDF}
        />
      )}
      {ActForm[documentType] && (
        <SigningActTasks
          actId={document.id}
          actType={documentType as ActFormKeys}
          canShowSigningActions={canShowSigningActions}
          rights={rights}
          toReopenInspection={toReopenInspection}
          onUpdatePDF={onUpdatePDF}
        />
      )}
    </Box>
  )
}

export default SigningTasks
